import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { Products } from './pages/products/products';
import { Cart } from './pages/cart/cart';
import { Login } from './pages/login/login';
import { Register } from './pages/register/register';
import { SingleProduct } from './pages/single-product/single-product';
import { Orders } from './pages/orders/orders';
import { Profile } from './pages/profile/profile';
import { Gifts } from './pages/gifts/gifts';
import { Designs } from './pages/designs/designs';
import { provideClientHydration } from '@angular/platform-browser';
import { RenderMode } from '@angular/ssr';
import { VerifyEmail } from './pages/verify-email/verify-email';
import { ForgotPassword } from './pages/forgot-password/forgot-password';
import { authGuard } from './guards/auth-guard';
import { Role } from './models/user';
import { PrivacyPolicy } from './pages/privacy-policy/privacy-policy';
import { TermsAndConditions } from './pages/terms-and-conditions/terms-and-conditions';
import { ReturnAndRefundPolicy } from './pages/return-and-refund-policy/return-and-refund-policy';
import { ShippingPolicy } from './pages/shipping-policy/shipping-policy';

export const routes: Routes = [
  // { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '', component: Home },
  { path: 'products', component: Products },
  { path: 'products/:id', component: SingleProduct },
  {
    path: 'cart',
    component: Cart,
    canActivate: [authGuard],
    data: { roles: [Role.CUSTOMER] },
  },
  {
    path: 'profile',
    component: Profile,
    canActivate: [authGuard],
    data: { roles: [Role.CUSTOMER] },
  },
  {
    path: 'orders',
    component: Orders,
    canActivate: [authGuard],
    data: { roles: [Role.CUSTOMER] },
  },
  // {
  //   path: 'gifts',
  //   component: Gifts,
  //   canActivate: [authGuard],
  //   data: { roles: [Role.CUSTOMER] },
  // },
  // {
  //   path: 'designs',
  //   component: Designs,
  //   canActivate: [authGuard],
  //   data: { roles: [Role.CUSTOMER] },
  // },
  { path: 'sign-in', component: Login },
  { path: 'sign-up', component: Register },
  { path: 'verify-email', component: VerifyEmail },
  { path: 'forgot-password', component: ForgotPassword },
  { path: 'privacy-policy', component: PrivacyPolicy },
  { path: 'terms-and-conditions', component: TermsAndConditions },
  { path: 'return-and-refund-policy', component: ReturnAndRefundPolicy },
  { path: 'shipping-policy', component: ShippingPolicy },
  { path: '**', redirectTo: '' },
];
